module.exports = {
    controller: correlationTableNewsController,
    templateUrl: 'correlation-table/components/correlation-table-news-page.html'
};

correlationTableNewsController.$inject = ['$analytics', '$routeParams'];

function correlationTableNewsController($analytics, $routeParams) {

    var vm = {
        $onInit: attached,
        activeSubnav: $routeParams.activeSubnav
    };

    function attached() {
        $analytics.pageTrack('/news/correlation-table');
    }
    
    return vm;
}
